<template>
  <div
    class="product-item"
    :class="{
      'product-item--grey': theme === 'grey',
      multiSelectMode: multiSelectMode,
    }"
  >
    <div class="product-item__tools-wrapper flex items-center gap-5">
      <a-tooltip placement="top" overlayClassName="ant-tooltip--step-nav">
        <template slot="title">
          <span>Share this project</span>
        </template>
        <div
          class="
            product-item__tools-btn product-item__tools-btn--share
            font-size-16
          "
          @click="shareModal = true"
        >
          <font-awesome-icon icon="share" />
        </div>
      </a-tooltip>

      <a-tooltip placement="top" overlayClassName="ant-tooltip--step-nav">
        <template slot="title">
          <span v-if="!product.Pinned">Pin this project</span>
          <span v-else>Unpin this project</span>
        </template>
        <div
          class="product-item__tools-btn"
          v-if="showBookmarkBtn"
          :class="{ 'product-item__tools-btn--pinned': product.Pinned }"
          @click="$emit('pin-project', product)"
        >
          <Loader class="space-0" v-if="loadingPinProject"></Loader>
          <font-awesome-icon icon="star" v-else />
        </div>
      </a-tooltip>
    </div>

    <a-dropdown :trigger="['click']">
      <a class="product-item__dropdown-btn" @click.prevent>
        <font-awesome-icon icon="ellipsis-v" />
      </a>
      <template #overlay>
        <a-menu>
          <a-menu-item key="0" v-if="product.SurveyStatus === 'Complete'">
            <a-button
              type="link"
              class="flex items-center"
              @click="$emit('view-report', product)"
            >
              <span class="ant-btn-icon-wrapper">
                <font-awesome-icon icon="file" />
              </span>
              View Report
            </a-button></a-menu-item
          >

          <a-menu-item key="1" v-if="product.SurveyStatus !== 'Draft'">
            <a-button
              type="link"
              class="flex items-center"
              @click="$emit('get-summary', product)"
            >
              <span class="ant-btn-icon-wrapper">
                <font-awesome-icon icon="poll-h" />
              </span>
              Summary
            </a-button></a-menu-item
          >

          <a-menu-item key="2" v-if="product.SurveyStatus === 'Draft'">
            <a-button
              type="link"
              class="flex items-center"
              @click="$emit('edit', product)"
            >
              <span class="ant-btn-icon-wrapper">
                <font-awesome-icon icon="edit" />
              </span>
              Edit
            </a-button></a-menu-item
          >

          <a-menu-item
            key="3"
            v-if="
              ['Queued', 'Report Preparation', 'In Field'].includes(
                product.SurveyStatus
              )
            "
          >
            <a-button
              type="link"
              class="flex items-center"
              @click="$emit('define-report', product)"
            >
              <span class="ant-btn-icon-wrapper">
                <font-awesome-icon icon="file" />
              </span>
              Define Report
            </a-button></a-menu-item
          >

          <a-menu-item
            key="4"
            v-if="
              (product.SurveyStatus === 'Report Preparation' ||
                product.SurveyStatus === 'Report Uploaded') &&
              user.AccountType === 'Master/Hotspex'
            "
          >
            <a-button
              type="link"
              class="flex items-center"
              @click="$emit('open-upload-report-modal', product)"
            >
              <span
                class="ant-btn-icon-wrapper ant-btn-icon-wrapper--upload-report"
              >
                <font-awesome-icon icon="file-upload" />
              </span>
              Upload Report
            </a-button></a-menu-item
          >

          <a-menu-item
            key="5"
            v-if="
              (product.SurveyStatus === 'Report Preparation' ||
                product.SurveyStatus === 'Report Uploaded') &&
              user.AccountType === 'Master/Hotspex' &&
              user.SkinIdentifier === 'pg'
            "
          >
            <a-button
              type="link"
              class="flex items-center"
              @click="$emit('open-upload-raw-data-modal', product)"
            >
              <span
                class="
                  ant-btn-icon-wrapper ant-btn-icon-wrapper--upload-raw-report
                "
              >
                <i></i>
              </span>
              Upload Raw data
            </a-button></a-menu-item
          >

          <a-menu-item
            key="6"
            v-if="
              product.SurveyStatus === 'Report Preparation' ||
              product.SurveyStatus === 'Complete'
            "
          >
            <a-button
              type="link"
              class="flex items-center"
              @click="$emit('download-data', product)"
            >
              <span class="ant-btn-icon-wrapper">
                <font-awesome-icon icon="download" class="" />
              </span>
              Survey data
            </a-button></a-menu-item
          >

          <a-menu-item key="7">
            <a-button
              type="link"
              class="flex items-center"
              @click="
                $emit('show-survey-services-modal', {
                  surveyID: product.SurveyID,
                  surveyName: product.SurveyName,
                  modalType: 'moveSurveyModal',
                })
              "
            >
              <span class="ant-btn-icon-wrapper">
                <font-awesome-icon icon="expand-arrows-alt" />
              </span>
              Move
            </a-button></a-menu-item
          >

          <a-menu-item key="8" v-if="!hideCopyBtn">
            <a-button
              type="link"
              class="flex items-center"
              @click="
                $emit('show-survey-clone-modal', {
                  surveyID: product.SurveyID,
                  surveyName: product.SurveyName,
                  modalType: 'cloneSurveyModal',
                })
              "
            >
              <span class="ant-btn-icon-wrapper"
                ><font-awesome-icon icon="copy"
              /></span>
              Copy
            </a-button></a-menu-item
          >

          <a-menu-item key="9" v-if="product.SurveyStatus !== 'Queued'">
            <a-button
              type="link"
              class="flex items-center"
              @click="
                $emit('delete-survey', {
                  surveyID: product.SurveyID,
                  surveyName: product.SurveyName,
                })
              "
            >
              <span class="ant-btn-icon-wrapper">
                <font-awesome-icon icon="trash-alt" />
              </span>
              Delete
            </a-button></a-menu-item
          >

          <a-menu-item key="10" v-if="user.planID === 4">
            <a-button
              type="link"
              class="flex items-center"
              @click="
                $emit('view-log', {
                  surveyID: product.SurveyID,
                  surveyName: product.SurveyName,
                })
              "
            >
              <span class="ant-btn-icon-wrapper">
                <font-awesome-icon icon="eye" style="width: 14px" />
              </span>
              View Log
            </a-button></a-menu-item
          >

          <a-menu-item
            key="11"
            v-if="
              product.SurveyStatus !== 'Draft' &&
              product.SurveyTypeName === 'Pack Test'
            "
          >
            <a-button
              type="link"
              class="flex items-center"
              @click="$emit('add-leg', product)"
            >
              <span class="ant-btn-icon-wrapper">
                <font-awesome-icon icon="plus" style="width: 14px" />
              </span>
              Add a Leg
            </a-button></a-menu-item
          >
          <a-menu-item
            key="12"
            v-if="
              product.SurveyStatus === 'Report Preparation' ||
              product.SurveyStatus === 'In Field'
            "
          >
            <a-button
              type="link"
              class="flex items-center"
              @click="$emit('open-upload-tabplan-modal', product)"
            >
              <span
                class="ant-btn-icon-wrapper ant-btn-icon-wrapper--upload-report"
              >
                <font-awesome-icon icon="file-upload" />
              </span>
              Upload Tabplan
            </a-button></a-menu-item
          >
        </a-menu>
      </template>
    </a-dropdown>
    <div class="product-item__flag" :style="statusStyle">
      {{ product.SurveyStatus }}

      <font-awesome-icon
        v-if="user.AccountType.toLowerCase() === 'master/hotspex'"
        icon="pencil-alt"
        @click="$emit('edit-status', product)"
        class="cursor-pointer"
      />
    </div>
    <div
      class="product-item__inner"
      :class="{ 'product-item__inner--pb80': showMainCta && product.manageURL }"
      @click="$emit('click', product)"
    >
      <div
        class="product-item__image"
        :class="{
          'product-item__image--contain':
            product.SurveyTypeName.toLowerCase() === 'pack test',
        }"
      >
        <div class="product-item__action">
          <span>{{ rowCaptionContent }}</span>
        </div>
        <img :src="product.imageUrl" alt="" v-if="product.imageUrl" />
        <icon-base
          v-else-if="product.SurveyTypeName.toLowerCase() === 'pack test'"
          :width="64"
          :height="64"
          :viewBox1="64"
          :viewBox2="64"
          iconName="packtest"
          iconColor="#9e9e9e"
          iconStroke="#9e9e9e"
          ><icon-packtest
        /></icon-base>
        <icon-base
          v-else
          :width="74"
          :height="74"
          :viewBox1="64"
          :viewBox2="64"
          iconName="packvideotest"
          iconColor="#9e9e9e"
          iconStroke="#9e9e9e"
          ><icon-videotest
        /></icon-base>
      </div>
      <div class="product-item__info">
        <h3>{{ product.SurveyTypeName }}</h3>
        <div class="flex-1">
          <h2>{{ product.SurveyName || "/" }}</h2>
          <div class="product-item__info-tags">
            <span v-if="product.CountryName">{{ product.CountryName }}</span
            ><span v-if="product.Retailer">{{ product.Retailer }}</span
            ><span v-if="product.category">{{ product.category }}</span
            ><span v-if="product.creativeStage">{{
              product.creativeStage
            }}</span>
          </div>
        </div>
        <div
          class="product-item__info-author"
          :class="{ 'product-item__info-author--hide': multiSelectMode }"
        >
          <i>
            <icon-base
              :width="35"
              :height="36"
              :viewBox1="24"
              :viewBox2="24"
              iconName="user"
              iconColor="transparent"
              iconStroke="#7e7e7e"
              ><icon-user /></icon-base
          ></i>
          <div>
            <span
              ><strong>{{ product.LaunchedBy }}</strong></span
            >
            <span>{{ product.Date_Created }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="multiSelectMode" class="product-item__multi-check-wrapp">
      <i
        :class="{
          'is-active': multiSelectMode,
          'opacity-05': multiCheckProducts.includes(product.SurveyID),
        }"
        >Select project</i
      >
      <a-checkbox
        class="multi-check"
        @change="$emit('multi-check-products', $event.target.checked)"
        :checked="multiCheckProducts.includes(product.SurveyID)"
      >
      </a-checkbox>
    </div>
    <div v-if="multiSelectMode" class="product-item__overlay"></div>
    <a-button
      type="primary"
      class="mt-30 -mb-5 product-item__main-cta"
      v-if="showMainCta && product.manageURL && mainCtaLabel !== ''"
      @click="$emit('main-cta-click', product)"
    >
      {{ mainCtaLabel }}
    </a-button>
    <a-modal
      title="Share Project"
      :visible="shareModal"
      @cancel="(shareModal = false), (shareEmails = '')"
      :width="400"
      centered
      okText="Share"
      cancelText="Cancel"
      :okButtonProps="{
        props: { disabled: !isSendEnabled, loading: loadingShareProject },
      }"
      @ok="shareProject"
    >
      <div class="input-group input-group--small">
        <label>
          Please enter the email addresses of the users you want to share the
          selected project with. You can add multiple email addresses, each on a
          new line.
        </label>
        <a-textarea v-model="shareEmails" :auto-size="{ minRows: 4 }" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import IconBase from "@/components/general/IconBase.vue";
import IconUser from "@/components/icons/IconUser.vue";
import IconPacktest from "@/components/icons/IconPackTest.vue";
import IconVideotest from "@/components/icons/IconVideoTest.vue";
import Loader from "@/components/general/Loader.vue";
import * as wsUtils from "@/utils/wsUtils.js";
import { gtagMixin } from "@/mixins/gtagMixin";

export default {
  name: "ProductItem",
  components: {
    IconBase,
    IconUser,
    IconPacktest,
    IconVideotest,
    Loader,
  },
  props: {
    product: {
      type: Object,
      default() {
        return "";
      },
    },
    user: {
      type: Object,
      default() {
        return "";
      },
    },
    theme: {
      type: String,
    },
    hideCopyBtn: {
      type: Boolean,
    },
    showBookmarkBtn: {
      type: Boolean,
    },
    loadingPinProject: {
      type: Boolean,
    },
    showMainCta: {
      type: Boolean,
    },
    multiSelectMode: {
      type: Boolean,
    },
    multiCheckProducts: {
      type: Array,
    },
  },
  mixins: [gtagMixin],
  data() {
    return {
      shareModal: false,
      shareEmails: "",
      loadingShareProject: false,
    };
  },
  computed: {
    statusStyle() {
      switch (this.product.SurveyStatus) {
        case "Report Preparation":
          return { backgroundColor: "#007bff" };
        case "Draft":
          return { backgroundColor: "#6c757d" };
        case "Queued":
          return { backgroundColor: "#17a2b8" };
        case "In Field":
          return { backgroundColor: "#28a745" };
        case "Complete":
          return { backgroundColor: "#218838" };
        case "In QA":
          return { backgroundColor: "#6f42c1" };
        case "Queuing Failed":
          return { backgroundColor: "#dc3545" };
        default:
          return {};
      }
    },
    rowCaptionContent() {
      const statusActions = {
        Complete: "View report",
        Draft: "Edit study",
        "In QA":
          this.product.QALink !== "APIFailed"
            ? "Test study"
            : "No Logit Survey URL",
        Queued: "View Summary",
        "Report Preparation": "View Summary",
        "In Field": this.user.planID === 4 ? "Monitor Quotas" : "View Summary",
      };

      return statusActions[this.product.SurveyStatus] || "";
    },
    mainCtaLabel() {
      const surveyStatus = this.product.SurveyStatus.toLowerCase();
      return surveyStatus === "in qa"
        ? "Launch"
        : surveyStatus === "in field"
        ? "Manage"
        : "";
    },
    isSendEnabled() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      const emailsArray = this.shareEmails
        .replace(/\s+/g, " ")
        .trim()
        .split(" ");

      return emailsArray.every((email) => emailRegex.test(email));
    },
  },
  methods: {
    validateEmails(emailArray) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailArray.every((email) => emailRegex.test(email));
    },
    shareProject(type) {
      this.loadingShareProject = true;
      const emailsArray = this.shareEmails
        .replace(/\s+/g, " ")
        .trim()
        .split(" ");
      if (!this.validateEmails(emailsArray)) {
        this.$notification["error"]({
          message: "Oops!",
          description: "Please enter valid email addresses.",
          placement: "bottomLeft",
          duration: 8,
        });
        return;
      }
      const data = {
        wsName: "ShareProject",
        data: {
          userID: this.user.EncrypteduserID,
          projectid: [this.product.SurveyID],
          emails: emailsArray,
          confirm_external_share: type === "confirm" ? true : null,
          folderID: [],
        },
      };

      const shareProject = new Promise((resolve) => {
        wsUtils.ApiPost(data, resolve);
      });

      shareProject.then((data) => {
        if (!data.success) {
          if (data.error_code === "USERS_NOT_FOUND") {
            this.$notification["info"]({
              message: "Oops!",
              description: (h) =>
                h("div", {}, [
                  h("p", {}, data.message),
                  h("div", {}, "Email(s):"),
                  ...data.not_found_emails.map((email) => h("div", {}, email)),
                ]),
              placement: "bottomLeft",
              duration: 12,
            });
          } else if (data.error_code === "EXTERNAL_ACCOUNT") {
            let _this = this;
            this.$confirm({
              title: "Confirm Sharing Project",
              content: () => {
                const emailCount = data.not_found_emails.length;
                const accountText =
                  emailCount === 1 ? "external account" : "external accounts";
                const emailLabel = emailCount === 1 ? "Email" : "Emails";
                const emailsList = data.not_found_emails.join(", ");
                return (
                  <div>
                    You are sharing this project with {emailCount} {accountText}
                    .
                    <br />
                    Are you sure you want to do this?
                    <br />
                    <strong>{emailLabel}:</strong> {emailsList}
                  </div>
                );
              },
              onOk() {
                _this.shareProject("confirm");
              },
              width: "425px",
              okText: "Yes",
              onCancel() {},
            });
          }
        } else {
          this.$notification["success"]({
            message: "Success!",
            description: "The project has been shared successfully.",
            placement: "bottomLeft",
            duration: 4,
          });
          this.shareEmails = "";
          this.shareModal = false;
          this.trackEvent("project_share", "", this.product, 1);
        }
        this.loadingShareProject = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-item {
  position: relative;
  text-align: left;
  border-bottom: 1px solid #dbdbdb;
  height: 100%;
  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: var(--white-100, #fff);
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.15);
  transition: all 0.25s ease;

  &:hover:not(.multiSelectMode) {
    border-color: var(--red);
    .product-item {
      &__action {
        opacity: 1;
        span {
          transform: translateY(0);
        }
      }
    }
  }

  &__inner {
    padding: 20px 20px 25px;
    cursor: pointer;
    height: 100%;
    display: flex;
    flex-direction: column;
    &--pb80 {
      padding-bottom: 80px;
    }
  }

  ::v-deep .multi-check.ant-checkbox-wrapper {
    .ant-checkbox {
      .ant-checkbox-inner {
        width: 26px;
        height: 26px;
        border-color: var(--red);
        border-width: 2px;
        border-radius: 6px;
        &:after {
          width: 7.714286px;
          height: 15.142857px;
          top: 45%;
        }
      }
    }
    .ant-checkbox-checked::after {
      border-radius: 6px;
    }
  }

  &__action {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 2px;
    z-index: 1;
    opacity: 0;
    transition: all 0.25s ease;
    &:before {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(0deg, #ffffff 50%, #f6f6f6 100%);
      z-index: -1;
      opacity: 0.95;
    }
    span {
      transform: translateY(-10px);
      transition: all 0.25s ease;
    }
  }

  &__flag {
    position: absolute;
    top: 30px;
    left: -1px;
    background: #369be1;
    color: #fff;
    z-index: 2;
    font-size: 13px;
    border-radius: 0 6px 6px 0;
    padding: 3px 10px 3px 10px;
    font-weight: 500;
    box-shadow: -5px 0px 15px 1px rgba(0, 0, 0, 0.2);
    letter-spacing: 1px;
    svg {
      margin-left: 4px;
    }
  }
  &__tools-wrapper {
    position: absolute;
    top: 32px;
    right: 55px;
    z-index: 3;
  }
  &__tools-btn {
    cursor: pointer;
    color: #949292;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    &--pinned {
      color: var(--hsblueDark);
    }
    &--share {
      transform: translateY(1px);
    }
  }
  &__dropdown-btn {
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 3;
    cursor: pointer;
    background: #fff;
    padding: 2px 5px;
    border-radius: 4px;
    box-shadow: 0 0px 15px 1px rgba(0, 0, 0, 0.2);
  }
  &__image {
    border-radius: 8px;
    margin-bottom: 18px;
    padding-bottom: 60.95%;
    position: relative;
    background: #f6f6f6;
    overflow: hidden;
    &:after {
      border-radius: 6px;
      position: absolute;
      inset: 0;
      content: "";
      background: rgba(0, 0, 0, 0.6);
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
    }
    img {
      max-width: 100%;
      border-radius: 8px;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    svg {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    &--contain {
      img {
        object-fit: contain;
        max-width: 80%;
        max-height: 80%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  &__cta {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    .ant-btn {
      margin: 10px;
      min-width: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        margin-right: 5px;
      }
    }
  }
  &__info {
    display: flex;
    flex-direction: column;
    flex: 1;
    h2 {
      color: var(--dark);
      font-size: 18px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: -0.4px;
      margin-bottom: 13px;
      flex: 1;
    }
    h3 {
      font-size: 13px;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-bottom: 2px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  &__info-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    span {
      border-radius: 3px;
      background: #f5f5f5;
      font-size: 12px;
      padding: 2px 7px;
      display: block;
      white-space: nowrap;
      font-weight: 400;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 200px;
    }
  }
  &__info-author {
    display: flex;
    align-items: center;
    margin: 30px 0 0;
    transition: opacity 0.3s ease;
    > div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    i {
      width: 34px;
      min-width: 34px;
      height: 34px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      background: #e8e8e8;
      ::v-deep svg {
        width: 24px;
        path {
          &:last-child {
            fill: #7e7e7e;
          }
        }
      }
    }

    span {
      display: block;
      font-size: 13px;
      color: #686868;
      line-height: normal;
      strong {
        font-size: 14px;
        font-weight: 400;
        color: #000;
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    &--hide {
      opacity: 0;
    }
  }
  &__overlay {
    position: absolute;
    inset: 0;
    z-index: 1;
    background: rgba(255, 256, 256, 0.65);
    z-index: 3;
    inset: -1px;
    border-radius: 20px;
  }

  &__multi-check-wrapp {
    position: absolute;
    right: 26px;
    bottom: 26px;
    z-index: 4;
    gap: 20px;
    display: flex;
    align-items: center;
    .opacity-05 {
      opacity: 0.5;
    }
    i {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      background: 4px;
      background: #fff;
      padding: 8px 12px;
      border-radius: 10px;
      box-shadow: 0 0 30px -2px rgba(0, 0, 0, 0.15);
      position: relative;
      transform: translate(0, -2px);
      transition: all 0.3s ease;
      animation: moveLeftRight 0.35s ease-in-out;

      &:after {
        content: "\25ba";
        position: absolute;
        left: 99%;
        top: 8px;
        color: #fff;
        font-size: 15px;
      }
    }
  }

  @keyframes moveLeftRight {
    0% {
      transform: translate(-35px, -2px);
    }
    50% {
      transform: translate(0, -2px);
    }
    75% {
      transform: translate(-20px, -2px);
    }
    100% {
      transform: translate(0, -2px);
    }
  }

  &.shadow-0 {
    box-shadow: none;
  }
  &--grey {
    background: linear-gradient(
      333deg,
      rgba(252, 252, 252, 1) 0%,
      rgba(244, 244, 244, 1) 100%
    );
    border: 1px solid transparent;
    box-shadow: none;
    .product-item__image,
    .product-item__info-tags span {
      background: #fff;
    }
  }
  &__main-cta {
    position: absolute;
    left: 20px;
    bottom: 25px;
    right: 20px;
  }
}

.ant-btn-icon-wrapper {
  &--upload-raw-report {
    margin-left: -3px;
    margin-right: 3px;
    i {
      display: block;
      margin-left: 2px;
      width: 14px;
      height: 16px;
      background: url("data:image/png;base64,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");
      background-size: cover;
    }
  }
}

::v-deep .ant-dropdown-menu-item {
  padding: 0;
  .ant-btn {
    padding: 5px 12px;
    width: 100%;
  }
}
::v-deep .ant-btn-icon-wrapper {
  min-width: 20px;
  display: inline-flex;
  align-items: center;
}
</style>
